// extracted by mini-css-extract-plugin
module.exports = {"loader-container":"BestSellerProductsLoader_loader-container__XLMSi","loader":"BestSellerProductsLoader_loader__OHpQe"};